<script>
    import { Spinner } from 'sveltestrap'
    
    import { SubTaskPhotos } from '../middleware/database/photos'

    export let taskId
    export let subtaskId
    export let id
    
    export let diameter = 60
    export let alt = ''
    export let src = ''

    let loading = true

/*
    const loaded = new Map()
    function lazy(node, data) {
        SubTaskPhotos.findOne(taskId, subtaskId, id)
            .then(url => {
                
                src = url
                
                const img = new Image()
                img.src = url
                img.onload = () => {
                    loaded.set(url, img);
                    node.setAttribute('src', url);
                }
                loading = false
                
            })
            .catch(err => {
                console.log(err)
            })

		return {
			destroy() {
			}
		};
    }

use:lazy={{dummy: '123'}}
<img src="/images/big-spinner.gif" class="rounded-circle p-1" {alt} width={diameter} height={diameter} />
*/

    $: if (loading) {
        SubTaskPhotos.findOne(taskId, subtaskId, id)
            .then(url => {
                src = url
                loading = false                
            })
            .catch(err => {
                console.log(err)
            })
    }
</script>



{#if (loading)}
    <Spinner color="secondary" type="grow" size="lg" />
{:else}
    <a href={src} target="_blank">
        <img {src} class="rounded-circle p-1" {alt} width={diameter} height={diameter} />
    </a>
{/if}

